import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { HubEndpoint } from '../../constants/hub-endpoint';
import { API_URL } from '../../../../../../services/config';
import { switchMap } from 'rxjs/operators';
import { HubItemFacade } from '../hub-item.facade';
import { YardSpotConfigurationModel } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class YardSpotConfigurationService {
  hubId: number;

  constructor(private http: WrapperHttpService, private hubItemFacade: HubItemFacade) {}

  getYardSpotListData(): Observable<YardSpotConfigurationModel[]> {
    return this.hubItemFacade.hubId$.pipe(
      switchMap((id: number) => {
        const url = `${API_URL}${HubEndpoint.Base}/${id}${HubEndpoint.ParkingSpots}`;

        return this.http.withLoading().get<YardSpotConfigurationModel[]>(url);
      }),
    );
  }

  createYardSpot(yardSpot: YardSpotConfigurationModel): Observable<YardSpotConfigurationModel> {
    return this.hubItemFacade.hubId$.pipe(
      switchMap((id: number) => {
        const url = `${API_URL}${HubEndpoint.Base}/${id}${HubEndpoint.ParkingSpots}`;

        return this.http.post<YardSpotConfigurationModel>(url, yardSpot);
      }),
    );
  }

  deleteYardSpot(yardSpotId: number): Observable<void> {
    return this.hubItemFacade.hubId$.pipe(
      switchMap((id: number) => {
        return this.http
          .withLoading()
          .delete<void>(`${API_URL}${HubEndpoint.Base}/${id}${HubEndpoint.ParkingSpots}/${yardSpotId}`);
      }),
    );
  }
}
